import { ListKlassesFilters } from '@/data/services/klassServices';
import Filter from '@/components/filter/Filter';
import { TeacherSummaryCount } from '../TeacherSummaryCount';
import { useKlassFilters } from '@/data/hook/useKlassFilters';
import User from '@/models/User';

type TeachingWeekFiltersProps = {
  user: User;
  update(params: Partial<ListKlassesFilters>): void;
  filter: ListKlassesFilters;
};

export default function TeachingWeekFilters({
  update,
  filter,
  user,
}: TeachingWeekFiltersProps) {
  const { configs } = useKlassFilters({ user, filter });

  return (
    <section className="flex flex-wrap gap-5 order-last items-center xl:self-end">
      <Filter
        configs={configs}
        onChange={update}
        filter={filter}
        hideQuick
        className={{ base: 'flex' }}
      />
      <TeacherSummaryCount filter={filter} />
    </section>
  );
}
